import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'standalone_checkout';
export const route = 'standalone/checkout/[shoppingBasketID]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "membershipstandalonecampaignscheckout" */
'../../components/MembershipStandaloneCampaignsCheckout')));